import React from "react";

const MessageText = ({ title }) => {
  return (
    <div className="container my-3">
      <h4 className="text-danger text-center">{title}</h4>
    </div>
  );
};

export default MessageText;
